import styles from './styles.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckCircle, faTicket, faXmark } from '@fortawesome/free-solid-svg-icons';
import errorMsg from '../../../Functions/errorMsg';
import successMsg from '../../../Functions/successMsg';
import { useSession } from 'next-auth/react';
import React, { useEffect, useRef, useState } from 'react';

import { motion } from 'framer-motion';

import { QrScanner } from '@yudiel/react-qr-scanner';
import axios from 'axios';
import { BarLoader, MoonLoader } from 'react-spinners';

import NumberFormat from 'react-number-format';
import { QRCode } from 'react-qrcode-logo';

export default function EventScanner({ listingID, closeScanner }) {

    const { data: session, status } = useSession();

    const [loadingTickets, setLoadingTickets] = useState(null);
    const [ticketData, setTicketData] = useState(null);

    function setTicketVerified(paymentIntentID) {
        if (!ticketData) return;

        // Find the index of the ticket with the matching paymentIntentID
        const index = ticketData.findIndex(ticket => ticket.paymentIntentID === paymentIntentID);

        // If the ticket with the given paymentIntentID is found
        if (index !== -1) {
            // Update the verified property to true
            const updatedTicketData = [...ticketData];
            updatedTicketData[index] = {
                ...updatedTicketData[index],
                verified: true
            };
            setTicketData(updatedTicketData);
        }
        successMsg("Ticket has been verified!");
    }
    
    useEffect(() => {
        if(!session) return;
        if(status !== 'authenticated') return;
        if(loadingTickets !== null) return;

        async function loadTickets() {
            setLoadingTickets(true);

            const getTicketsAPI = await axios.post(`${window.location.origin}/api/eventHub/tickets/getEventTickets`, {
                userID: session.user.token.id,
                eventID: listingID
            }).catch((error) => {
                errorMsg(error?.response?.data?.status || error.toString())
            });

            if(getTicketsAPI && getTicketsAPI.status === 200) {
                setTicketData(getTicketsAPI.data);
            }

            setLoadingTickets(false)
        }

        loadTickets()

    }, [session, status, loadingTickets])

    const [scannedURL, setScannedURL] = useState(null);
    const [loadingResult, setLoadingResult] = useState(false);
    const [result, setResult] = useState(null);

    const [flash, setFlash] = useState(false);

    function handledScannedQR(string) {
        if(scannedURL === string) return;
        setScannedURL(string);
        setFlash(true);
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            setFlash(false);
        }, 50);

        return () => clearTimeout(timeout);
    }, [flash]);

    useEffect(() => {
        if(scannedURL === null) return;
        if(loadingResult === true) return;
        if(result !== null) return;
        if(!session) return;
        if(status !== 'authenticated') return;

        async function verifyLink() {
            const code = scannedURL;

            const eventID = listingID.substring(0, 8);
            const eventID_URL = code.substring(0, 8);

            if(eventID === eventID_URL) {
                setLoadingResult(true);

                const response = await axios.post(`${window.location.origin}/api/eventHub/tickets/verifyTicket`, {
                    verifyingUserID: session.user.token.id,
                    eventID: listingID,
                    code: code,
                }).catch((error) => {
                    errorMsg(error?.response?.data?.status || error.toString())
                });

                if(response && response.status === 200) {
                    setResult(response.data.ticketData);

                    if(response.data.justVerified === true) {
                        setTicketVerified(response.data.ticketData.paymentIntentID);
                    }

                    setTimeout(() => {
                        setScannedURL(null);
                        setLoadingResult(false);
                    }, 1000)
                }

                setLoadingResult(false);
            } else {
                errorMsg("This ticket does not belong to this event.");
            }

        }

        verifyLink();

    }, [result, scannedURL, loadingResult, session, status])

    const [loadingQRLogo, setLoadingQRLogo] = useState(false);

    function isLoading() {
        if(loadingResult !== false) return 'result';
        if(loadingTickets !== false) return 'tickets';
        if(loadingQRLogo === true) return 'result'
        return false
    }

  return (
    <section id={styles.wrapper}>
        {flash && (
            <motion.div
                id={styles.flashOverlay}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.1 }}
            />
        )}
        <FontAwesomeIcon icon={faXmark} id={styles.exit} onClick={() => closeScanner()} />

        <div id={styles.content}>
            <section>
                {
                    isLoading() === 'result' ? <MoonLoader size={60} color='black' /> :
                    <>
                        <h1>QR Ticket Scan</h1>
                        <div id={styles.logoMatch}>
                            <QRCode id={styles.exampleQR} logoOnLoad={() => setLoadingQRLogo(false)} value="EXAMPLE-QR-CODE" logoImage='/financehub/exchange-icon.png' logoWidth={34} logoHeight={34} bgColor='transparent' qrStyle='dots' fgColor='#154734' eyeRadius={10} eyeColor='#154734' />
                        </div>
                        <QrScanner key='environment' constraints={{ facingMode: 'environment' }} onDecode={(result) => handledScannedQR(result)} onError={(error) => errorMsg(error.message)} />
                    </>
                }
            </section>

            <section>
                { isLoading() === 'result' && <div id={styles.loading} style={{zIndex: '2'}} > <BarLoader color='black' size={40} /> <h1>Verifying Ticket</h1>  </div> }
                { isLoading() === 'tickets' && <div id={styles.loading} style={{zIndex: '1'}}> <BarLoader color='black' size={40} /> <h1>Loading Tickets</h1>  </div> }
                { isLoading() === false && <TicketsContainer listingID={listingID} ticketData={ticketData} setTicketVerified={setTicketVerified} /> }
                { result !== null && <div id={styles.resultContainer}>
                <FontAwesomeIcon icon={faXmark} id={styles.exitResult} onClick={() => setResult(null)} />
                <section id={styles.purchaseTotal}>Purchase Total: <b style={{fontWeight: '400'}}>${parseFloat(result.amount / 100).toLocaleString()}</b></section>
                <div>
                    <FontAwesomeIcon icon={faCheckCircle} id={styles.icon} />
                    <h1>Verified Ticket Purchase</h1>
                </div>
                <div>
                    <h1>Unique Code: <b>{result.verifyToken}</b></h1>
                    <h1>PaymentID: <b>{result.paymentIntentID}</b></h1>
                </div>
                <div>
                    <h1>Purchased Items</h1>
                    <section>
                        { result.purchased.map((item, index) => {
                            return (
                                <div key={index}>
                                    <h1>{item.name} - ${parseFloat(item.price)} / ea</h1>
                                    <h1>Ordered: {item.quantityOrdered}</h1>
                                </div>
                            )
                        }) }
                    </section>
                </div>
            </div> }
            </section>


        </div>


    </section>
  )
}

const TicketsContainer = ({ listingID, ticketData, setTicketVerified }) => {
    if(ticketData === null || ticketData === undefined) return;

    return (
        <section id={styles.ticketContainer}>
            { ticketData.length === 0 && <div id={styles.noTickets}><h1>No Tickets</h1></div> }
            { ticketData.length > 0 && ticketData.map((ticket, index) => <TicketCard key={index} listingID={listingID} ticket={ticket} setTicketVerified={setTicketVerified} /> ) }
        </section>
    )
}

const TicketCard = ({ listingID, ticket, setTicketVerified }) => {

    const { data: session, status } = useSession();

    const [loadingVerifying, setLoadingVerifying] = useState(false);
    const [ticketStatus, setTicketStatus] = useState(ticket.verified);

    const [inputValues, setInputValues] = useState(['', '', '']);
    const inputRefs = useRef([React.createRef(), React.createRef(), React.createRef()]);

    async function manualVerifyTicket(paymentIntentID) {
        if(!session) return errorMsg("You're not authenticated, please login or refresh the page.");
        if(status !== 'authenticated') return errorMsg("You're not authenticated, please login or refresh the page.");

        const eventID = listingID.substring(0, 8);
        const completeCode = eventID + '-' + inputValues[0] + "-" + inputValues[1] + "-"+ inputValues[2];

        if(completeCode.length !== 23) return errorMsg("Please enter in a full-code."); 

        setLoadingVerifying(true);


        const response = await axios.post(`${window.location.origin}/api/eventHub/tickets/verifyTicket`, {
            verifyingUserID: session.user.token.id,
            eventID: listingID,
            code: completeCode,
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        });

        if(response && response.status === 200) {
            setTicketStatus(true);
            setTicketVerified(paymentIntentID);
        }

        setLoadingVerifying(false);
    }    

    const handleInputChange = (index, value) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = value;
        setInputValues(newInputValues);

        if (value.length === 4 && index < 2 && inputRefs.current[index + 1]) {
            inputRefs.current[index + 1].focus();
        }

        if (value.length === 0 && index === 2 && inputRefs.current[index - 1]) {
            inputRefs.current[index - 1].focus();
        }

        if (value.length === 0 && index === 1 && inputRefs.current[index - 1]) {
            inputRefs.current[index - 1].focus();
        }
    };

    return (
        <section className={styles.ticketCard}>
            
            <div>
                <h1>{ticketStatus ? <b style={{color: '#FFFFFF', backgroundColor: '#0da00d', padding: '4px 7px', borderRadius: '12px', fontSize: '0.9rem'}}>Verified <FontAwesomeIcon icon={faCheck} /> </b> : 'Not Verified'}</h1>
                <h2>Total: <b>${(parseFloat(ticket.amount) / 100).toLocaleString()}</b></h2>
            </div>

            <div>
                {ticket.purchased.map((item, index) => (
                    <section key={index}>
                        <span>
                            <h1>{item.quantityOrdered} <FontAwesomeIcon icon={faTicket} id={styles.icon} /></h1>
                            <h2>{item.name}</h2>
                        </span>
                        <h3>${parseFloat(item.price * item.quantityOrdered).toLocaleString()}</h3>
                    </section>
                ))}
            </div>

            <div>
                <div style={{display: ticketStatus === true ? 'none' : 'flex'}}>
                    <span id={styles.code}>
                        <h1>{listingID.substring(0, 8)}</h1>
                        <h2>-</h2>
                        <span>
                        {[0, 1, 2].map((index) => (
                                <NumberFormat
                                    key={index}
                                    value={inputValues[index]}
                                    format="####"
                                    mask="_"
                                    placeholder="0000"
                                    onValueChange={({ value }) => handleInputChange(index, value)}
                                    getInputRef={(ref) => (inputRefs.current[index] = ref)}
                                />
                            ))}
                        </span>
                    </span>
                    <button onClick={() => manualVerifyTicket(ticket.paymentIntentID)}>{loadingVerifying ? <BarLoader color='white' width={40} /> : 'Manual Verify'}</button>
                </div>
                <h1>PaymentID: <b>{ticket.paymentIntentID}</b></h1>
            </div>
        </section>
    );
};